<template>
  <div>
    <!-- 新增的固定布局 view -->
    <!-- <div class="top-fixed-view"> -->
    <div :class="['top-fixed-view', { active: isActive }]">
      <img :class="['left-image', { active: isActive }]" :src="require('../assets/images/homeV2/logoV2.png')"
        alt="Left Image" />
      <div class="button-container" @mouseenter="showAboutList" @mouseleave="hideAboutList">
        <button :class="['about-us-button', { active: isActive }]" @click.stop="mobileShowAboultList">
          <div v-if="!isMobile">
            <span class="button-text">关于我们</span>
          </div>
          <div v-else>
            <img class="button-img" :src="menueUrl" />
          </div>

        </button>

        <!-- 透明间隔 -->
        <div class="nav-gap"></div>
        <!-- 列表 -->
        <div v-show="isListVisible" :class="['about-list', { active: isActive }]">

          <ul>
            <li v-for="(item, index) in aboutItems" :key="index" :class="{ active: selectedIndex === index }"
              @click="handleItemClick(index)">
              {{ item.text }}
            </li>
          </ul>
        </div>

      </div>

    </div>
    <div v-if="isMobile" v-show="isListVisible" class="block-view"> </div>

    <div v-if="isMobile">
      <img v-show="isScrolled" class="back-to-top" :src="require('../assets/images/homeV2/backTopV2.png')"
        @click="scrollToTop" />
    </div>

    <!-- 视频容器 -->
    <div ref="videoContainer" class="video-container">
      <div class="video-container__inner">
        <!-- <img class="img-placeHolder" ref="placeholder" :src="require('../assets/images/homeV2/homeImgV2.png')"/> -->
        <video id="my-video" ref="videoPlayer" class="video-js vjs-default-skin" preload="auto" data-setup="{}"
          :muted="!isMobile" playsinline x5-video-player-type="h5" webkit-playsinline x5-playsinline>
          <!-- <source src="@/assets/video/homeV2.mp4" type="video/mp4" /> -->
        </video>
      </div>

      <!-- 没有视频先去掉  v-show="false"-->
      <button v-show="false" v-if="!isPlaying && !isMobile" class="big-pause-icon" @click="togglePlay">
        <img :src="require('../assets/images/homeV2/bigPlayV2.png')" alt="play icon" />
      </button>

      <!-- 没有视频先去掉 v-show="false" -->
      <!-- 自定义的播放控制面板 -->
      <div v-show="false" v-if="!isMobile" class="controls-container" @mouseenter="controlsVisible = true"
        @mouseleave="controlsVisible = false">
        <div v-show="controlsVisible" class="custom-controls-wrapper">
          <!-- <div  class="custom-controls-wrapper"> -->
          <div class="custom-controls">


            <!-- 第一行：播放按钮、时间显示、音量控制 -->
            <div class="controls-top-row">
              <button @click="togglePlay">
                <img
                  :src="isPlaying ? require('../assets/images/homeV2/pasueV2.png') : require('../assets/images/homeV2/playV2.png')"
                  alt="Play/Pause Icon" class="play-pause-icon" />
              </button>

              <!-- 时间显示 -->
              <div class="time-display">
                <span>{{ currentTime | formatTime }}</span> / <span>{{ totalTime | formatTime }}</span>
              </div>

              <!-- 音量控制 -->
              <div class="volume-bar-wrapper" @mouseenter="onMouseEnter">
                <div class="volume-background-wrapper" @click="seekVolume">
                  <div ref="volumeContainer" class="volume-background" @click="seekVolume"></div>
                  <div ref="volumeFilled" class="volume-filled">
                    <div ref="volumeHandle" class="volume-handle" @mousedown="startVolumeDragging"></div>
                  </div>
                </div>
                <img :src="volumeIconurl" alt="volume icon" class="volume-icon" @click="volumeIconClicked" />
              </div>


            </div>

            <!-- 进度条 -->
            <div ref="progressContainer" class="custom-progress-bar" @click="seekVideo">
              <div class="progress-background"></div>
              <div ref="bufferedBar" class="progress-buffered"></div>
              <div ref="progressBar" class="progress-filled">
                <div ref="progressHandle" class="progress-handle" @mousedown="startDragging"></div>
              </div>
            </div>

          </div>
        </div>
      </div>



    </div>
    <!-- 下方模块部分 -->
    <div class="modules-container">
      <div id="intro" class="module">
        <TitleWithImage :imageSrc="url" title="公司简介" />
        <p class="intro-text">
          心田花开是一家致力于用科技手段服务教育的大型综合性教育科技集团，历经近二十年发展，已跻身行业领先地位。
        </p>
        <div class="card-container first-row">
          <CardComponent class="card1"
            :backgroundImage="isMobile ? require('../assets/images/homeV2/info2V2H5.png') : require('../assets/images/homeV2/info2V2.png')"
            title="教学业务" description="涵盖软硬件产品开发、图书出版与文创、素质教育、在线教育、AI直播等多个领域。" descriptionColor="#677E79" />
          <CardComponent class="card2"
            :backgroundImage="isMobile ? require('../assets/images/homeV2/info4V2H5.png') : require('../assets/images/homeV2/info4V2.png')"
            title="教学产品" description="覆盖情商体系、自然科学、西方人文、国学、演讲与口才、书法、美术、绘画、魔方等多个学科。" descriptionColor="#66858F" />
        </div>

        <!-- 第二行卡片 -->
        <div class="card-container second-row">
          <CardComponent class="card3"
            :backgroundImage="isMobile ? require('../assets/images/homeV2/info1V2H5.png') : require('../assets/images/homeV2/info1V2.png')"
            title="服务群体" description="为低幼、适龄青少年、中老年群体提供优质文娱产品和高质量服务。" descriptionColor="#6E859C" />
          <CardComponent class="card4"
            :backgroundImage="isMobile ? require('../assets/images/homeV2/info3V2H5.png') : require('../assets/images/homeV2/info3V2.png')"
            title="企业使命"
            description="心田花开始终秉持“帮孩子成长，助家庭幸福，为政府解忧，让社会满意，成就全体员工事业人生”的企业使命，通过自身业务的稳步发展，为社会优秀人才和高校优秀毕业学子切实解决就业问题，为更多家庭输送优质教育产品和服务。"
            descriptionColor="#696D83" />
        </div>
      </div>

      <div id="mode" class="module">
        <TitleWithImage :imageSrc="url" title="教学模式" />
        <p class="teaching-description">
          公司采用线上线下融合的OMO教学模式，旗下拥有“花啦啦在线”线上教育产品，并在成都、重庆、西安、武汉、长沙、郑州、南京、杭州、广州、深圳等城市开设数百个线下教学中心，累计服务上千万家庭。
        </p>
        <div class="teaching-image-container">
          <img :src="require('../assets/images/homeV2/mapV2.png')" alt="教学模式" class="teaching-image" />
        </div>
      </div>

      <div id="vision">
        <div class="module">
          <TitleWithImage :imageSrc="url" title="企业愿景" />
        </div>
        <div class="vision-module">
          <!-- <img :src="require('../assets/images/terrace-banner-02.png')" alt="企业愿景" class="vision-image" /> -->
          <img :src="require('../assets/images/homeV2/yuanjingV2New.png')" alt="企业愿景" class="vision-image" />

          <div class="vision-text">
            帮孩子成长，助家庭幸福；
            <div class="text-gap"></div>
            为政府解忧，让社会满意，成就奋斗者事业人生！
          </div>
        </div>
      </div>


      <div id="history" class="back-ground">
        <div class="floating-module">
          <TitleWithImage :imageSrc="url" title="发展历程" />
        </div>

        <div class="swiper-container-lc">
          <div v-show="!isMobile" class="swiper-button">
            <button class="prev-button" :disabled="isPrevDisabled" :class="{ 'disabled': isPrevDisabled }"
              @click="prevSlide">
              <img :src="prevButtonImage" alt="prev">
            </button>
            <button class="next-button" :disabled="isNextDisabled" :class="{ 'disabled': isNextDisabled }"
              @click="nextSlide">
              <img :src="nextButtonImage" alt="next">
            </button>
          </div>

          <swiper ref="mySwiper" class="swiper-lc" :options="swiperOptions">
            <swiper-slide v-for="(v, i) in sources" :key="i">
              <SwiperSlideComponent :text="v.text" :description="v.description" :isActive="activeIndex === i"
                :isFirst="i === 0" :isLast="i === sources.length - 1" @slideClick="handleSlideClick(i)" />
            </swiper-slide>
          </swiper>
        </div>

      </div>

      <!-- PC有边距 在Module里 移动端不在 -->
      <div v-if="!isMobile" id="responsibility" class="module">
        <TitleWithImage :imageSrc="url" title="社会责任" />
        <div class="swiper-container-zr">
          <div v-show="!isMobile" class="swiper-button-zr">
            <button class="prev-button-zr" :disabled="isPrevDisabledZR" :class="{ 'disabled': isPrevDisabledZR }"
              @click="prevSlideZR">
              <img :src="prevButtonImageZR" alt="prevZR">
            </button>
            <button class="next-button-zr" :disabled="isNextDisabledZR" :class="{ 'disabled': isNextDisabledZR }"
              @click="nextSlideZR">
              <img :src="nextButtonImageZR" alt="nextZR">
            </button>
          </div>

          <swiper ref="mySwiperZR" class="swiper-zr" :options="swiperOptionsZR">
            <swiper-slide v-for="(v, i) in sourcesZR" :key="i">
              <SwiperSlideComponentZR :id="v.id" :title="v.title" :description="v.intro" :image="v.image"
                @slideZRClick="ZRDetail" />
            </swiper-slide>
          </swiper>
        </div>

      </div>

      <div v-else>
        <div id="responsibility" class="module">
          <TitleWithImage :imageSrc="url" title="社会责任" />
        </div>
        <div class="swiper-container-zr">
          <div v-show="!isMobile" class="swiper-button-zr">
            <button class="prev-button-zr" :disabled="isPrevDisabledZR" :class="{ 'disabled': isPrevDisabledZR }"
              @click="prevSlideZR">
              <img :src="prevButtonImageZR" alt="prevZR">
            </button>
            <button class="next-button-zr" :disabled="isNextDisabledZR" :class="{ 'disabled': isNextDisabledZR }"
              @click="nextSlideZR">
              <img :src="nextButtonImageZR" alt="nextZR">
            </button>
          </div>

          <swiper ref="mySwiperZR" class="swiper-zr" :options="swiperOptionsZR">
            <swiper-slide v-for="(v, i) in sourcesZR" :key="i">
              <SwiperSlideComponentZR :id="v.id" :title="v.title" :description="v.intro" :image="v.image"
                @slideZRClick="ZRDetail" />
            </swiper-slide>
          </swiper>
        </div>

      </div>
    </div>


    <div v-if="!isMobile" class="botton-view">
      <div class="top-section">
        <div class="left-part">
          <!-- 左边的内容 -->
          <img class="left-image-bottom" :src="require('../assets/images/homeV2/logoV2.png')" alt="Company Image" />
          <div class="text-row">
            <span class="left-text" @click="handleItemClick(0, true)">公司简介</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(1, true)">教学模式</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(2, true)">企业愿景</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(3, true)">发展历程</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(4, true)">社会责任</span>
            <span class="separator-line"></span>
            <span class="left-text" @click="handleItemClick(5, true)">人才招聘</span>
          </div>
        </div>
        <div class="separator"></div> <!-- 竖线 -->
        <div class="right-part">
          <!-- 右边的内容 -->
          <div class="right-content">
            <h2 class="right-title">加入我们</h2>
            <p class="right-subtitle">扫描下方二维码，投递简历，了解更多招聘信息</p>
            <div class="qr-code-container">
              <div class="qr-item">
                <img class="qr-code" :src="require('../assets/images/homeV2/zpQRCodeV2.png')" alt="QR Code 1" />
                <span class="qr-text">心田花开招聘网</span>
              </div>
              <div class="qr-item">
                <img class="qr-code" :src="require('../assets/images/homeV2/gzhQRCodeV2.png')" alt="QR Code 2" />
                <span class="qr-text">心田花开招聘公众号</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-section">
        <p class="foot-beiAn" @click="clickBeiAn">蜀ICP备2024069709号-1</p>
        <p>Copyright © 成都心田花开心语教育管理有限公司 2016 - 2024. All right reserved</p>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div v-else class="botton-view-mobile">
      <img class="top-image" :src="require('../assets/images/homeV2/logoV2.png')" alt="Top Image" />
      <div class="separator-line-mobile"></div>
      <h2 class="mobile-title">加入我们</h2>
      <p class="mobile-subtitle">扫描下方二维码，投递简历，了解更多招聘信息</p>
      <div class="mobile-qr-code-container">
        <div class="mobile-qr-item">
          <img class="mobile-qr-code" :src="require('../assets/images/homeV2/zpQRCodeV2.png')" alt="QR Code 1" />
          <span class="mobile-qr-text">心田花开招聘网</span>
        </div>
        <div class="mobile-qr-item">
          <img class="mobile-qr-code" :src="require('../assets/images/homeV2/gzhQRCodeV2.png')" alt="QR Code 2" />
          <span class="mobile-qr-text">心田花开招聘公众号</span>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import TitleWithImage from '@/components/homeV2/TitleWithImage.vue'
import CardComponent from '@/components/homeV2/CardComponent.vue'
import SwiperSlideComponent from '@/components/homeV2/SwiperSlideComponent.vue'
import SwiperSlideComponentZR from '@/components/homeV2/SwiperSlideComponentZR.vue'
import { getDutyList } from '@/libs/api'
import { browser, os } from '@/utils/common'
const dom = document.documentElement
export default {
  components: {
    swiper,
    swiperSlide,
    TitleWithImage,
    CardComponent,
    SwiperSlideComponent,
    SwiperSlideComponentZR
  },

  filters: {
    formatTime (seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = Math.floor(seconds % 60)
      return `${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    },
  },
  data () {
    return {
      isScrolled: false,// 判断是否滚动超过一屏

      isDraggingVolume: false,
      isDragging: false, // 视频是否正在拖动
      isActive: false,

      isScrollingToIntro: false,
      scrollTimeout: null, // 用于保存定时器 ID
      lastScrollTop: 0, // 记录上次滚动位置,上划还是下滑
      player: null,
      isPlaying: false,
      currentTime: 0,
      totalTime: 0,
      volume: 1, // 默认音量
      progress: 0, // 默认进度
      buffered: 0,

      controlsVisible: false,
      url: require('../assets/images/homeV2/iconV2.png'),
      volumeIconurl: require('../assets/images/homeV2/voiceIconV2.png'),
      // 静音
      volumeOff: false,


      activeIndex: 7, // 默认激活最后一个 slide
      isPrevButtonClicked: false,
      isNextButtonClicked: false,
      sources: [
        { description: '心田花开在成都建校，形成以情商语文为核心，多学科发展的办学模式。', text: '2013' },
        { description: '心田花开理科、心田花开英语和心田花开国学成立，以语文为核心的中小学全科体系形成。', text: '2015' },
        { description: '重庆分校成立，优秀办学模式实现复制裂变。', text: '2016' },
        { description: '武汉、西安、郑州、长沙分校成立，在线教育平台——心田花开网校投入运营，心田花开确立了线上线下相融合的OMO战略发展模式。', text: '2018' },
        { description: '广州、深圳、南京、杭州分校成立，向沿海一线城市扩张发展。', text: '2019' },
        { description: '积极响应国家“五育并举”政策，大力拓展素质教育项目，书法、语言、绘画、研学、魔方等素养和文旅业务迅速发展。', text: '2022' },
        { description: '加快现代化智能技术发展的步伐，是国内率先研发AI教育技术的推动者之一，引领教育领域信息化变革;同时，推动教育直播项目落地，强化线上线下融合发展模式。', text: '2023' },
        { description: '深化银发经济“蓝海”布局，持续推动现有业务和新业务做大做强。', text: '2024' },
      ],
      swiperOptions: this.getSwiperOptions(),


      activeIndexZR: 0,
      isPrevButtonClickedZR: false,
      isNextButtonClickedZR: false,
      // <img :src="v.image" alt />
      //             <div class="item-title">{{ v.title }}</div>
      //           </div>
      //           <div class="item-con" v-html="v.intro">{{ v.content }}</div>
      sourcesZR: [
        { image: 'https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/20200402/1585813282203.jpg', title: '公益直播课：抗击疫情，心田花开在行动！', intro: '心田花开全面响应与落实国家部署，向全国学子提供免费直播课，为教育同仁提供网课技术支持。抗击疫情，心田花开在行动！' },
        { image: 'https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/20200402/1585813110150.JPG', title: '爱国主义系列活动：以我之声，颂我之国！', intro: '为了让孩子更好地感受中华民族精神、文学魅力，心田花开策划爱国主义专题活动，陶冶孩子爱国情操，弘扬爱国主义精神' },
        { image: 'https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/20200402/1585813166107.PNG', title: '传统文化系列活动：中国诗词大会总冠军的“特殊课堂', intro: '情商语文融合诗词冠军之力，希望通过传统文化系列活动，让孩子们成为优秀的传统文化传承者，会学语文，会生活！' },
        { image: 'https://xthk-cms-admin.oss-cn-shenzhen.aliyuncs.com/20200331/1585618079412.PNG', title: '习惯百日行公益行动：感谢坚持的你，善良的你！', intro: '习惯百日行在孩子们的心中悄悄播下了两颗种子，一颗叫坚持，另一颗叫爱心。习惯百日行的路上有爱同行，助力公益！' },

      ],
      swiperOptionsZR: this.getSwiperOptionsZR(),

      isListVisible: false,
      selectedIndex: null, // 当前选中的 item
      aboutItems: [
        { text: '公司简介', sectionId: 'intro' },
        { text: '教学模式', sectionId: 'mode' },
        { text: '企业愿景', sectionId: 'vision' },
        { text: '发展历程', sectionId: 'history' },
        { text: '社会责任', sectionId: 'responsibility' },
        { text: '人才招聘', sectionId: '' }
      ],

      swiperOptionsSUM: {
        direction: 'vertical', // 竖直方向
        loop: false, // 是否循环
        slidesPerView: 1, // 每页显示的 slide 数量
        mousewheel: true, // 启用鼠标滚轮控制
      },

      moudeIndex: null
    }


  },
  computed: {
    isMobile () {
      return browser.isMobile
    },
    menueUrl () {
      if (this.isListVisible === true) {
        return require('../assets/images/homeV2/closeV2.png')
      } else {
        return require('../assets/images/homeV2/menueV2.png')
      }
    },

    //   isMobile() {
    //   return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // },

    // swiper() {
    //   return this.$refs.mySwiper.swiper
    // },
    prevButtonImage () {
      if (this.isPrevDisabled) {
        return require('../assets/images/homeV2/leftDisV2.png')
      }
      return this.isPrevButtonClicked
        ? require('../assets/images/homeV2/leftActiveV2.png')
        : require('../assets/images/homeV2/leftNomalV2.png')
    },
    nextButtonImage () {
      if (this.isNextDisabled) {
        return require('../assets/images/homeV2/rightDisV2.png')
      }
      return this.isNextButtonClicked
        ? require('../assets/images/homeV2/rightActiveV2.png')
        : require('../assets/images/homeV2/rightNomalV2.png')
    },
    isPrevDisabled () {
      return this.activeIndex === 0
    },
    isNextDisabled () {

      return this.activeIndex >= 5
    },


    prevButtonImageZR () {
      if (this.isPrevDisabledZR) {
        return require('../assets/images/homeV2/leftDisV2.png')
      }
      return this.isPrevButtonClickedZR
        ? require('../assets/images/homeV2/leftActiveV2.png')
        : require('../assets/images/homeV2/leftNomalV2.png')
    },
    nextButtonImageZR () {
      if (this.isNextDisabledZR) {
        return require('../assets/images/homeV2/rightDisV2.png')
      }
      return this.isNextButtonClickedZR
        ? require('../assets/images/homeV2/rightActiveV2.png')
        : require('../assets/images/homeV2/rightNomalV2.png')
    },
    isPrevDisabledZR () {
      return this.activeIndexZR === 0
    },
    isNextDisabledZR () {
      return this.activeIndexZR >= this.sourcesZR.length - 3
    }
  },
  watch: {
    isListVisible (v) {
      if (!v) {
        if (this.isMobile) {
          this.$refs.videoPlayer.style.visibility = 'visible'
        }
      }

      this.$nextTick(() => {
        if (this.isMobile) {
          dom.style.overflow = v ? 'hidden' : 'auto'
        }
      })

    }
  },
  created () {
    console.log(browser, os)
    document.documentElement.scrollTop = 0
    this.lastScrollTop = 0
  },
  mounted () {

    this.moudeIndex = this.$route.query.index
    if (this.moudeIndex !== undefined && this.isMobile === false) {
      console.log('跳转到index', this.moudeIndex)
      this.isScrollingToIntro = true

      window.scrollTo({ top: 0, behavior: 'auto' })
      setTimeout(() => {
        // 页面滚动到对应模块
        const sectionId = ['intro', 'mode', 'vision', 'history', 'responsibility'][this.moudeIndex]
        const targetElement = document.getElementById(sectionId)
        targetElement.scrollIntoView({ behavior: 'smooth' })
        this.selectedIndex = this.moudeIndex
        if (this.isMobile === false) {
          this.isActive = true
        }

      }, 200)

      setTimeout(() => {
        window.addEventListener('scroll', this.handleScroll)

        this.lastScrollTop = document.documentElement.scrollTop
        this.isScrollingToIntro = false

      }, 1000)


    } else {
      window.addEventListener('scroll', this.handleScroll)
    }

    document.addEventListener('click', this.handleOutsideClick)

    if (this.isMobile === true) {
      // 更新swiperOptions中的pre值
      this.swiperOptions.slidesPerView = 1.5
      this.swiperOptions.spaceBetween = -14
      this.swiperOptionsZR.slidesPerView = 1.3
      this.swiperOptionsZR.spaceBetween = 0

      // 如果swiper实例已经创建，更新它
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        this.$refs.mySwiper.swiper.params.slidesPerView = 1.5
        this.$refs.mySwiper.swiper.params.spaceBetween = -14
        this.$refs.mySwiper.swiper.update()
        // 获取滑块的总数
        const totalSlides = this.$refs.mySwiper.swiper.slides.length
        // 使用 slideTo() 方法滑动到最后一个滑块
        this.$refs.mySwiper.swiper.slideTo(totalSlides - 1)

      }
      if (this.$refs.mySwiperZR && this.$refs.mySwiperZR.swiper) {
        this.$refs.mySwiperZR.swiper.params.slidesPerView = 1.3
        this.$refs.mySwiperZR.swiper.params.spaceBetween = 0
        this.$refs.mySwiperZR.swiper.update()
      }
    }


    const ctx = this
    // 初始化 video.js
    this.player = videojs(this.$refs.videoPlayer, {
      controls: false,
      // autoplay: !this.isMobile,
      autoplay: false,
      loop: false,
      preload: 'auto',
      aspectRatio: '16:9',
      poster: require('../assets/images/homeV2/homeImgV2.jpg')
    },
      function onPlayReady () {
        console.log('视频可以播放啦~~~')

        if (!ctx.isMobile) {
          // ctx.player.muted = true
          ctx.player.play()
        } else {
          ctx.player.pause()
        }

        /**
         * 监听内部事件
         */
        this.on('loadstart', function () {
          console.log('开始请求数据 ')
        })
        this.on('progress', function () {
          console.log('正在请求数据 ')
        })
        // this.on("loadedmetadata", function () {
        //     console.log("获取资源长度完成 ")
        // })
        // this.on("canplaythrough", function () {
        //     console.log("视频源数据加载完成")
        //     this.player.play();
        // })
        this.on('waiting', function () {
          console.log('等待数据')
        })
        // this.on("play", function () {
        //     console.log("视频开始播放")
        // });
        this.on('playing', function () {
          console.log('视频播放中')
        })
        // this.on("pause", function () {
        //     console.log("视频暂停播放")
        // });
        // this.on("ended", function () {
        //     console.log("视频播放结束");
        // });
        this.on('error', function () {
          console.log('加载错误')
        })
        this.on('seeking', function () {
          console.log('视频跳转中')
        })
        // this.on('seeked', function () {
        //   console.log('视频跳转结束')
        // })
        this.on('ratechange', function () {
          console.log('播放速率改变')
        })
        // this.on("timeupdate", function () {
        //     console.log("播放时长改变");
        // })
        this.on('volumechange', function () {
          console.log('音量改变')
        })
        this.on('stalled', function () {
          console.log('网速异常')
        })

      })

    /// 没有视频先去掉
    // if (this.isMobile) {
    //   this.player.ready(() => {
    //     this.player.controls(true) // 显示控制条
    //   })
    // }


    this.player.on('timeupdate', this.updateTime)
    this.player.on('loadedmetadata', this.setTotalTime)
    this.player.on('play', this.startPlay)
    this.player.on('ended', this.endPlay)
    this.player.on('pause', this.pausePlay)
    this.player.on('seeked', this.seekend)

    // this.player.on("canplaythrough", this.beginPlay);


    // 自动隐藏控制器
    // this.hideControls();
    // 获取社会责任轮播数据
    this.getMsg()

  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('click', this.handleOutsideClick)

    if (this.player) {
      this.player.dispose()
    }
  },

  methods: {

    // 点击备案
    clickBeiAn () {
      // 打开新窗口
      window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
    },

    /// 点击音量图标
    volumeIconClicked () {
      if (this.volumeOff) {
        this.volumeIconurl = require('../assets/images/homeV2/voiceIconV2.png')
        this.volumeOff = false
        this.updateVolume(1)

      } else {
        this.volumeIconurl = require('../assets/images/homeV2/voiceIconOff.png')
        this.volumeOff = true
        this.updateVolume(0)
      }

    },

    onMouseEnter () {
      this.$nextTick(() => {
        // 当鼠标进入时，计算宽度并更新音量
        this.updateVolume(this.volume)
      })
    },

    handleOutsideClick () {
      if (this.isMobile) {
        const button = this.$el.querySelector('.about-us-button')
        if (this.isListVisible && !button.contains(event.target)) {
          this.isListVisible = false
        }
      }

      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.muted = false
      }
    },

    handleScroll (event) {
      // if (this.moudeIndex !== undefined) {
      //   return
      // }
      this.isScrolled = window.scrollY > window.innerHeight - 60 // 超过一屏高度
      console.log('chaoguo', this.isScrolled)

      const videoContainer = this.$refs.videoContainer
      const rect = videoContainer.getBoundingClientRect()
      if (this.isMobile) {
        const inViewport = rect.bottom >= 44
        if (inViewport) {

        } else {

          this.player.pause()
        }
      } else {
        const inViewport = rect.bottom >= 0
        if (inViewport) {

        } else {
          this.isActive = true
          this.player.pause()
        }
      }

      console.log('this.isScrollingToIntro', this.isScrollingToIntro)
      if (this.isScrollingToIntro) return  // 如果是点击导致的滚动，不做处理

      const sections = this.aboutItems.map(item => document.getElementById(item.sectionId))
      let currentIndex = this.selectedIndex

      // 遍历所有 section 判断当前滚动位置
      for (let i = 0; i < sections.length - 1; i++) {
        const section = sections[i]
        if (section) {
          const rect = section.getBoundingClientRect()
          if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
            currentIndex = i
            break
          }
        }
      }

      // 如果发现新的 section，更新 selectedIndex
      if (currentIndex !== this.selectedIndex) {
        this.selectedIndex = currentIndex
      }



      if (this.isMobile) { ///  移动端不自动滚动
        return
      }
      this.onScrollStop(event)

    },

    onScrollStop (event) {
      if (this.isScrollingToIntro) return


      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop



      const changeOverflow = () => {
        event.preventDefault()
        event.stopPropagation()
        window.removeEventListener('scroll', this.handleScroll)
        dom.style.overflow = 'hidden'
        setTimeout(() => {
          window.addEventListener('scroll', this.handleScroll)
          dom.style.overflow = 'auto'
          this.lastScrollTop = document.documentElement.scrollTop
          this.isScrollingToIntro = false
        }, 800)
      }

      if (!this.lastScrollTop) {
        changeOverflow()
        dom.scrollTop = currentScrollTop
        this.$nextTick(() => {
          this.scrollToIntro()
        })

        return
      }

      else if (this.lastScrollTop > currentScrollTop) {
        dom.scrollTop = currentScrollTop
        const rect = this.$refs.videoPlayer.getBoundingClientRect()
        if (rect.bottom > 0 & rect.bottom < window.innerHeight) {
          changeOverflow()
          this.$nextTick(() => {
            this.scrollToTop()
          })

          return
        }
      }

      this.lastScrollTop = currentScrollTop
    },

    scrollToIntro () {
      this.isScrollingToIntro = true
      if (this.isMobile === false) {
        console.log('1111')
        this.isActive = true
      }

      console.log('滚动到 简介')

      window.scrollTo({ top: window.innerHeight + 80, behavior: 'smooth' })

      const currentTime = this.player.currentTime()
      const duration = this.player.duration()
      if (currentTime !== duration) {
        console.log('滚动离开视频区域,暂停')
        this.player.pause()
      }
      this.isPlaying = false

      console.log('scrollToIntro')
    },

    scrollToTop () {
      this.isScrollingToIntro = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.isActive = false
      console.log('scrollTop')
    },

    ZRDetail (id) {
      console.log('责任详情', id)

      if (this.isMobile) {
        this.$router.push({
          path: '/socialV2',
          query: { id: id }
        })

      } else {
        let routeUrl = this.$router.resolve({
          path: '/socialV2',
          query: { id: id }
        })
        window.open(routeUrl.href, '_blank')
      }

    },

    getMsg () {
      getDutyList({ status: 1 }).then(res => {
        this.sourcesZR = res.data.data
      })
    },

    // toggleAboutList () {
    //   this.isListVisible = !this.isListVisible
    // },

    showAboutList () {
      if (this.isMobile === false) {
        this.isListVisible = true
      }

    },

    hideAboutList () {
      if (this.isMobile === false) {
        this.isListVisible = false
      }

    },

    mobileShowAboultList () {
      if (this.isMobile === true) {
        this.isListVisible = !this.isListVisible
        this.$refs.videoPlayer.style.visibility = 'hidden'
      }
    },

    handleItemClick (index, isBottom) {
      // console.log('dianjiINDEX',index)
      !isBottom && (this.isListVisible = !this.isListVisible)
      /// 恢复滚动
      if (this.isMobile) {
        dom.style.overflow = 'auto'
      }

      if (index === 5) {
        // 打开新窗口
        window.open('https://xintianhuakai1.zhiye.com', '_blank')
      } else {
        this.selectedIndex = index // 更新选中的 index
        window.removeEventListener('scroll', this.handleScroll)
        this.isScrollingToIntro = true

        if (this.isMobile === false && !isBottom) {
          this.isActive = true
        }

        this.player.pause()

        setTimeout(() => {
          this.isScrollingToIntro = false
          window.addEventListener('scroll', this.handleScroll)
          this.lastScrollTop = document.documentElement.scrollTop
        }, 800)
        // 页面滚动到对应模块
        const sectionId = ['intro', 'mode', 'vision', 'history', 'responsibility'][index]
        const targetElement = document.getElementById(sectionId)
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        })
        // targetElement.scrollIntoView({ behavior: 'smooth',block:'start' })
      }
    },
    getSwiperOptions () {
      console.log('是否移动设备', this.isMobile)
      return {
        freeMode: true,
        slidesPerView: this.isMobile ? 1.5 : 3,
        spaceBetween: 0,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        initialSlide: 7, // 初始展示的 slide 设为最后一个
        on: {
          slideChange: () => {
            const swiper = this.$refs.mySwiper.swiper
            console.log('当前显示的 index:', swiper.activeIndex)
            this.activeIndex = swiper.activeIndex
            // || this.$refs.mySwiper.swiper.activeIndex <= 2
            // if (swiper.activeIndex <= 2) {
            //   isPrevDisabled == true
            // }

          }
        }
      }
    },

    handleSlideClick (index) {
      this.activeIndex = index // 点击后设置激活的滑块
    },

    getSwiperOptionsZR () {
      return {
        slidesPerView: this.isMobile ? 1.5 : 3,
        spaceBetween: this.isMobile ? 0 : 39,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        on: {
          slideChange: () => {
            const swiper = this.$refs.mySwiperZR.swiper
            console.log('当前显示的 index:', swiper.activeIndex,)
            this.$nextTick(() => {
              this.activeIndexZR = swiper.activeIndex
            })
            //
          }
        }
      }
    },

    // handleSlideClickZR(index) {
    //   this.activeIndexZR = index; // 点击后设置激活的滑块
    // },

    //     changeVolume(event) {
    //     this.volume = event.target.value;
    //     this.player.volume(this.volume);
    //   },
    //   seekVideo(event) {
    //   this.progress = event.target.value;
    //   const newTime = (this.progress / 100) * this.totalTime;
    //   this.player.currentTime(newTime);
    // },

    seekVolume (event) {
      const container = this.$refs.volumeContainer
      const rect = container.getBoundingClientRect()
      const clickPosition = event.clientX - rect.left
      const newVolume = clickPosition / rect.width
      this.updateVolume(newVolume)
    },
    startVolumeDragging (event) {
      const handleMouseMove = (e) => {
        const container = this.$refs.volumeContainer
        const rect = container.getBoundingClientRect()
        let newVolume = (e.clientX - rect.left) / rect.width
        if (newVolume === Infinity) {
          return
        }
        newVolume = Math.max(0, Math.min(newVolume, 1)) // 保证音量在 0 到 1 之间
        this.updateVolume(newVolume)
      }

      const stopVolumeDragging = () => {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', stopVolumeDragging)
      }

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', stopVolumeDragging)
    },
    updateVolume (volume) {
      const filled = this.$refs.volumeFilled
      const handle = this.$refs.volumeHandle
      const percentage = volume * 100 + '%'
      filled.style.width = percentage

      // 计算 filled 的宽度和 handle 的宽度
      const filledWidth = filled.clientWidth
      const handleWidth = handle.clientWidth

      // 同时处理 translateX 和 translateY
      handle.style.transform = `translate(${filledWidth - handleWidth / 2}px, -50%)`
      // 调用实际音量调整函数
      console.log(`当前音量: ${volume}`)
      this.volume = volume
      this.player.volume(volume)

      if (volume <= 0) {
        this.volumeIconurl = require('../assets/images/homeV2/voiceIconOff.png')
        this.volumeOff = true
      } else {
        this.volumeIconurl = require('../assets/images/homeV2/voiceIconV2.png')
        this.volumeOff = false
      }


    },




    // 开始拖动
    startDragging (event) {
      this.isDragging = true
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDragging)
    },

    // 拖动中
    onDrag (event) {
      if (!this.isDragging) return
      const progressBar = this.$refs.progressContainer
      const rect = progressBar.getBoundingClientRect()
      const dragX = event.clientX - rect.left
      const progress = Math.max(0, Math.min(dragX / rect.width, 1)) // 保证 progress 在 0~1 之间
      this.updateProgress(progress)
    },

    // 停止拖动
    stopDragging () {
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDragging)
    },

    // 更新进度条
    updateProgress (progress) {
      this.player.currentTime(progress * this.player.duration())
      this.progress = progress * 100
      this.$refs.progressBar.style.width = this.progress + '%'
    },


    seekVideo (event) {

      const progressBar = this.$refs.progressContainer
      const rect = progressBar.getBoundingClientRect()
      const clickX = event.clientX - rect.left
      const progress = Math.max(0, Math.min(clickX / rect.width, 1)) // 保证 progress 在 0~1 之间
      this.updateProgress(progress)

    },

    changeVolume () {
      console.log('ying亮', this.volume)
      this.player.volume(this.volume)
    },
    // 显示自定义控件
    showControls () {
      this.controlsVisible = true
    },
    hideControls () {
      if (!this.isMobile) {
        this.controlsVisible = false
      }
    },
    toggleControls () {
      if (this.isMobile) {
        this.controlsVisible = !this.controlsVisible
      }
    },
    togglePlay () {
      // if (this.player.paused()) {
      //   this.player.play();
      //   this.isPlaying = true;
      // } else {
      //   this.player.pause();
      //   this.isPlaying = false;
      // }
      if (this.isPlaying === false) {
        console.log('开始播放')
        this.player.play()
        this.isPlaying = true
      } else {
        console.log('暂停')
        this.player.pause()
        this.isPlaying = false
      }
    },
    updateTime () {
      const currentTime = this.player.currentTime()
      const duration = this.player.duration()
      const bufferedEnd = this.player.bufferedEnd()

      this.progress = (currentTime / duration) * 100
      this.buffered = (bufferedEnd / duration) * 100

      if (this.$refs.progressBar) {
        this.$refs.progressBar.style.width = this.progress + '%'
        this.$refs.bufferedBar.style.width = this.buffered + '%'
      }


      this.currentTime = currentTime

    },
    setTotalTime () {
      this.totalTime = this.player.duration()
    },
    startPlay () {
      this.isPlaying = true
    },
    endPlay () {
      console.log('结束')
      this.isPlaying = false
    },
    seekend () {
      console.log('视频跳转结束')
      const currentTime = this.player.currentTime()
      const duration = this.player.duration()
      if (currentTime === duration) {
        console.log('视频跳转结束,最后开始播放')
        this.player.play()
      }
    },

    pausePlay () {
      console.log('停止')
      this.isPlaying = false
    },
    beginPlay () {
      setTimeout(() => {

        if (this.player.paused()) {
          console.log('视频源数据加载完成开始播放')
          this.player.play()
          this.isPlaying = true
        }

      }, 1000)

    },


    prevSlide () {
      if (!this.isPrevDisabled) {
        this.isPrevButtonClicked = true
        setTimeout(() => {
          this.isPrevButtonClicked = false
        }, 200) // 按钮点击状态持续时间，例如200ms

        this.activeIndex--
        this.$refs.mySwiper.swiper.slidePrev()
      }
    },
    nextSlide () {
      if (!this.isNextDisabled) {
        this.isNextButtonClicked = true
        setTimeout(() => {
          this.isNextButtonClicked = false
        }, 200) // 按钮点击状态持续时间，例如200ms

        this.activeIndex++
        this.$refs.mySwiper.swiper.slideNext()
      }
    },

    prevSlideZR () {
      if (!this.isPrevDisabledZR) {
        this.isPrevButtonClickedZR = true
        setTimeout(() => {
          this.isPrevButtonClickedZR = false
        }, 200) // 按钮点击状态持续时间，例如200ms

        this.activeIndexZR--
        this.$refs.mySwiperZR.swiper.slidePrev()
      }
    },

    nextSlideZR () {

      if (!this.isNextDisabledZR) {
        this.isNextButtonClickedZR = true
        setTimeout(() => {
          this.isNextButtonClickedZR = false
        }, 200) // 按钮点击状态持续时间，例如200ms

        this.activeIndexZR++

        this.$refs.mySwiperZR.swiper.slideNext()
      }
    },
  },

}
</script>
<style>
.vjs-poster img{
 width:auto !important;
}
</style>
<style scoped lang="less">
body {
  overflow-x: hidden;
}

.img-placeHolder {
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}



.back-to-top {
  position: fixed;
  width: 60px;
  height: 60px;
  right: 16px;
  bottom: 68px;
  cursor: pointer;
  z-index: 999;
  transition: opacity 0.3s ease;
}

/* 顶部固定布局 */
.top-fixed-view {
  position: fixed;
  top: 38px;
  left: 208px;
  right: 208px;
  height: 80px;
  background-color: white;
  border-radius: 50px;
  /* 高度的一半，产生圆角 */
  z-index: 9999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.top-fixed-view.active {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-radius: 0px;
  padding: 0px;

}

/* 左侧图片 */
.left-image {
  height: 50px;
  width: auto;
}

/* 左侧图片 */
.left-image.active {
  margin-left: 208px;
}


.button-container {
  position: relative;
}

/* 按钮 */
.about-us-button {
  width: 124px;
  height: 50px;
  border: 1px solid #262626;
  border-radius: 25px;
  /* 椭圆形效果 */
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 41px;
  outline: none;
}

.about-us-button.active {
  margin-right: 208px;
}

.nav-gap {
  height: 41px;
  background-color: transparent;
}

.button-text {
  color: #262626;
  font-size: 18px;
  font-family: "PingFang SC-Regular";
}

/* 列表的样式 */
.about-list {
  position: absolute;
  right: -55px;
  top: 125px;
  width: 220px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
  z-index: 9999;
  border-radius: 24px;
  /* 设置8px的圆角 */
}

/* 列表的样式 */
.about-list.active {
  right: 163px;
}

.about-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.about-list li {
  height: 68px;
  line-height: 68px;
  font-size: 18px;
  font-family: "PingFang SC-Regular", sans-serif;
  color: #595959;
  text-align: center;
  cursor: pointer;
  border-bottom: 0.5px solid #eaeaea;
  /* 每个 item 之间的分割线 */
  transition: color 0.3s;
  /* 添加过渡效果 */
}

/* 最后一个item不要显示底部的分割线 */
.about-list li:last-child {
  border-bottom: none;
}

.about-list li:hover {
  background-color: #f5f5f5;
}

/* 鼠标悬浮时，第一个和最后一个item有圆角 */
.about-list li:first-child:hover {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
}

.about-list li:last-child:hover {
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

/* 点击后的选中效果 */
.about-list li.active {
  color: #05BD6F;
  /* 选中项文字变成绿色 */
}

/* .video-slide, .content-slide {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
} */
.controls-container {
  position: absolute;
  height: 220px;
  /* 设置一个固定高度或者根据需求调整 */
  width: 100%;
  /* 使其占据父容器的宽度 */
  /* top: -320px; */
  background-color: transparent;
  bottom: 0;
}

.custom-controls-wrapper {
  position: absolute;
  height: 220px;
  /* 设置一个固定高度或者根据需求调整 */
  width: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.38) 100%);
  bottom: 0;
}

/* 确保没有内外边距 */
.video-container {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.video-container .video-js {
  padding-bottom: 0 !important;
  height: 100%;
}


//  .vjs-poster {
//   background-color: rgb(61, 30, 219);
//   // left: 100px;
//   background-size: cover; /* 等比裁剪 */
//   background-position: center; /* 居中显示 */
//   background-repeat: no-repeat; /* 防止背景重复 */
// }

.video-container .video-js video {
  object-fit: cover !important;
  object-position: center !important;
}

@supports not (aspect-ratio: 16/9) {
  .video-container {
    padding-bottom: 56.25%;
    /* 16:9 aspect ratio */
  }
}

.video-container__inner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 保持视频比例并裁剪视频以适应容器 */
  margin: 0;
  padding: 0;
  /* display: block; */
  position: absolute;
  top: 0;
  left: 0;
}

.big-pause-icon {
  position: absolute;
  z-index: 100;
  background-color: transparent;
  top: 50%;
  /* 将其垂直居中 */
  left: 50%;
  /* 将其水平居中 */
  transform: translate(-50%, -50%);
  /* 用 transform 调整其真正的居中对齐 */
  padding: 0;
  border: 0;
}

.custom-controls {
  position: absolute;
  /* bottom: 0; */
  left: 208px;
  /* 距离播放器左边208px */
  right: 208px;
  /* 距离播放器右边208px */
  height: 220px;
  display: flex;
  flex-direction: column;
  /* 垂直布局 */
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 3;
}

/* 第一行容器，用于播放按钮、时间显示和音量控制 */
.controls-top-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 18px;
  /* 距离顶部18px */
  margin-bottom: 20px;
}

/* 播放按钮样式 */
.custom-controls button {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  padding: 0;
  /* 去除默认 padding */
  border: none;
  /* 去除默认边框 */
  background: transparent;
  /* 透明背景 */
  cursor: pointer;
  /* 鼠标样式 */
}

/* 图标样式 */
.play-pause-icon {
  width: 100%;
  /* 图标宽度适应按钮 */
  height: auto;
  /* 保持宽高比 */
}

/* 时间显示的样式 */
.time-display {
  display: flex;
  align-items: center;
  margin-right: auto;
  /* 左对齐时距音量控制器的间距 */
  font-size: 24px;
  /* 字体大小 */
  color: #fff;
  /* 文字颜色白色 */
  font-family: 'PingFang SC-Medium';
  /* 字体 */
}

.volume-bar-wrapper {
  position: relative;
  width: 70px;
  height: 70px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 0 15px; */
}

.volume-bar-wrapper:hover {
  width: 190px;
  justify-content: space-between;
}


.volume-background-wrapper {
  position: relative;
  display: none;
  width: 100px;
  height: 5px;
  border-radius: 2px;
  margin-left: 20px;
  // opacity: 0;
  cursor: pointer;
}

.volume-bar-wrapper:hover .volume-background-wrapper {
  // opacity: 1;
  display: block;
}

.volume-background {
  position: relative;
  width: 100%;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.volume-filled {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background-color: white;
  border-radius: 2px;
}

.volume-handle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  cursor: pointer;
}

.volume-icon {
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.volume-bar-wrapper:hover .volume-icon {
  margin-right: 20px;
}




.custom-progress-bar {
  position: relative;
  width: 100%;
  height: 4px;
  cursor: pointer;
  border-radius: 2px;
}

.progress-background {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #D8D8D8;
  opacity: 0.4;
  border-radius: 2px;
}

.progress-buffered {
  position: absolute;
  width: 0;
  height: 100%;
  background-color: #D8D8D8;
  border-radius: 2px;
}

.progress-filled {
  position: absolute;
  height: 100%;
  background: linear-gradient(to right, #05BD6F, #FFD700);
  width: 0;
  border-radius: 2px;
  top: 0px;
}

.progress-handle {
  position: absolute;
  right: 0;
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 50%;
  top: -4px;
  transform: translateX(50%);
  outline: 12px solid rgba(255, 255, 255, 0.3);
    /* 添加白色光晕 */
    outline-offset: -4px;
    /* 调整外边距，以便光晕在外 */
  }



  /* 模块容器样式 */
  .modules-container {
    padding: 0px;
    margin: 0;
    overflow: hidden
  }

  /* 每个模块的样式 */
  .module {
    // padding-top: 180px;
    padding-top: 60px;
    margin-left: 208px;
    /* 左右边距为208px */
    margin-right: 208px;
  }

  /* 公司简介文字样式 */
  .intro-text {
    // font-size: 28px;
    // font-family: 'PingFang SC', sans-serif;
    // color: #262626;
    margin-top: 40px;
    margin-bottom: 100px;
    padding: 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #262626;
    line-height: 40px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  /* 卡片容器样式 */
  .card-container {
    display: flex;
    flex-wrap: wrap;
    gap: 36px;

    * {
      box-sizing: border-box;
    }
  }

  @supports not (gap) {
    .card-container>* {
      margin-bottom: 16px;
    }

    .card-container>:last-child {
      margin-bottom: 0;
    }

  }

  /* 为第一行和第二行卡片容器设置垂直间距 */
  .first-row {
    margin-bottom: 36px;
    /* 第一行和第二行之间的垂直间距 */
  }

  .second-row {
    margin-top: 36px;
    /* 第二行和第一行的间距 */
  }

  /* 卡片基础样式 */
  .card {
    background-color: transparent;
    border-radius: 28px;
    display: flex;
    font-size: 18px;
    color: #333;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

  }

  .card p.title {
    white-space: nowrap;
  }


  .card:hover {
    // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    // border: 1px solid white;
    box-shadow: 0px 0px 28px 0px rgba(5, 52, 42, 0.12);
    border-radius: 28px 28px 28px 28px;
    border: 4px solid #FFFFFF;
  }

  /* PC端样式 */
  .card1 {
    width: 734px;
    height: 350px;
  }

  .card2 {
    flex: 1;
    /* 占用剩余宽度 */
    height: 350px;
    min-width: 0;
    /* 确保在空间不足时不会收缩到 0 */
  }

  .card3 {
    width: 432px;
    height: 386px;
  }

  .card4 {
    flex: 1;
    /* 占用剩余宽度 */
    height: 386px;
  }

  /* 描述文本样式 */
  .teaching-description {
    margin-top: 40px;
    font-size: 28px;
    // font-family: 'PingFang SC', sans-serif;
    // color: #262626;
    margin-bottom: 0;
    padding: 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #595959;
    line-height: 56px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  /* 图片容器 */
  .teaching-image-container {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 图片样式 */
  .teaching-image {
    height: auto;
    /* 保持宽高比 */
    width: 100%;
  }

  .vision-module {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-top: 100px;
  }

  .vision-image {
    width: 100%;
    height: auto;
  }

  .vision-text {
    position: absolute;
    text-align: center;
    color: white;
    font-size: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    /* Regular */
    white-space: pre-wrap;
    /* 保持换行 */
    z-index: 1;
    letter-spacing: 2px;
    text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.4);
    font-style: normal;
    text-transform: none;

  }

  .text-gap {
    height: 20px
  }

  .back-ground {
    width: 100%;
    /* aspect-ratio: 16 / 9; 设置宽高比为16:9 */
    background-color: #FAF9F6;
    padding-top: 60px;
  }

  .floating-module {
    margin-left: 208px;
    /* 左右边距为208px */
    margin-right: 208px;
    background-color: #FAF9F6;
  }


  .swiper-container-lc {
    padding-top: 60px;
    padding-bottom: 130px;
  }

  .swiper-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 40px;
  }

  .swiper-button button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .swiper-button img {
    width: 60px;
    height: 60px;
  }

  .prev-button {
    margin-right: 24px;
    /* 两个按钮之间的间距 40px */
  }

  .next-button {
    margin-right: 208px;
  }

  .swiper-lc {
    width: 100%;
    /* height: 619px; */
    margin-top: 0;
    margin-bottom: 0;
  }

  .swiper-zr {
    width: 100%;
    /* height: 732px; */
    /* aspect-ratio: 330 / 310; */
    /* margin-top: 80px;
    margin-bottom: 180px; */
  }


  .swiper-container-zr {

    margin-top: 60px;
    margin-bottom: 80px
  }

  .swiper-button-zr {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 40px
  }

  .swiper-button-zr button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .swiper-button-zr img {
    width: 60px;
    height: 60px;
  }

  .prev-button-zr {
    margin-right: 24px;
    /* 两个按钮之间的间距 40px */
  }

  .next-button-zr {
    margin-right: 0;
  }


  .botton-view {
    width: 100%;
    aspect-ratio: 1920 / 570;
    background-color: #F6F6F6;
    display: flex;
    flex-direction: column;
  }

  .top-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 58px;
  }

  .left-part {
    flex: 1;
    padding-left: 208px;
  }

  .left-image-bottom {
    margin-bottom: 68px;
  }

  .text-row {
    display: flex;
    align-items: center;
  }

  .left-text {
    font-size: 18px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: rgba(38, 38, 38, 0.85);
    cursor: pointer;
  }

  .left-text:hover {
    color: rgba(5, 189, 111, 0.85);
  }

  .separator-line {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #D8D8D8;
    margin: 0 20px;
  }

  .separator {
    width: 1px;
    height: 180px;
    background-color: #D8D8D8;
    margin-left: 119px;
    margin-top: 55px;
  }

  .right-part {
    flex: 1;
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    /* 垂直居中 */
    flex-direction: column;
  }

  .right-content {
    text-align: center;
  }

  .right-title {
    font-size: 18px;
    font-family: "PingFang SC-Medium", sans-serif;
    color: #262626;
    margin-bottom: 12px;
  }

  .right-subtitle {
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #8C8C8C;
    margin-bottom: 40px;
  }

  .qr-code-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 12px;
  }

  .qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .qr-code {
    width: 160px;
    height: 160px;
  }

  .qr-text {
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    margin-top: 12px;
    /* 距离二维码12px */
  }


  .bottom-section {
    text-align: center;
    font-size: 14px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #8C8C8C;
    line-height: 24px;
    margin-top: 90px;

  }

  .foot-beiAn {
    cursor: pointer;
  }

  .bottom-section p {
    margin: 0;
    display: inline-block;
    margin-right: 40px;
    /* 两段文字间距40px */
  }

  .bottom-section p:last-child {
    margin-right: 0;
  }

  .botton-view-mobile {
    width: 100%;
    aspect-ratio: 375 / 288;
    background-color: #F6F6F6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 28px;
  }

  .top-image {
    height: 27px;
    width: auto;
    object-fit: cover;
  }

  .separator-line-mobile {
    width: calc(100% - 32px);
    /* 左右16px的距离 */
    height: 1px;
    background-color: #EDEDED;
    margin: 10px 0;
  }

  .mobile-title {
    font-size: 12px;
    font-family: "PingFang SC-Medium", sans-serif;
    color: #262626;
    text-align: center;
    margin-top: 10px;
    margin-bottom: 0px;
  }

  .mobile-subtitle {
    font-size: 10px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    text-align: center;
    margin-top: 4px;
  }

  .mobile-qr-code-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 10px;
  }

  .mobile-qr-item {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-qr-code {
    width: 100px;
    height: 100px;
  }

  .mobile-qr-text {
    font-size: 10px;
    font-family: "PingFang SC-Regular", sans-serif;
    color: #595959;
    margin-top: 6px;
    /* 图片和文字之间的间距 */
  }



  /* 移动设备适配 */
  div.mobile {
    .top-fixed-view {
      position: fixed;
      left: 0;
      right: 0;
      height: 44px;
      top: 0;
      border-radius: 0;
      /* 移动设备上无圆角 */
      padding: 0;
    }

    .left-image {
      height: 22px;
      width: auto;
      margin-left: 16px;
      /* 移动端左侧间距缩小 */
    }

    .about-us-button {
      width: 20px;
      height: 20px;
      border: none;
      background: none;
      margin-right: 16px;
      background-position: center;
      background-repeat: no-repeat;

    }

    .button-text {
      display: none;
      /* 移动端隐藏文字 */
    }

    .button-img {
      width: 20px;
      height: 20px;
    }

    .block-view {
      position: absolute;
      width: 100vw;
      height: 1000vh;
      right: 0;
      background-color: rgba(0, 0, 0, 0.3);
      z-index: 2;
    }

    .about-list {
      width: 100vw;
      /* 列表宽度为100% */
      top: 72px;
      right: 0;
      background: #FFFFFF;
      box-shadow: 0px 4px 14px -4px rgba(0, 0, 0, 0.06);
      border-radius: 0px 0px 12px 12px;
    }

    .about-list li {
      height: 42px;
      /* 每个 item 的高度 */
      line-height: 42px;
      /* 使文本在高度内垂直居中 */
      font-size: 12px;
      /* 字体大小 */
    }

    .video-container {
      margin-top: 44px;
      /* 移动设备上视频播放器在 fixed view 下面显示 */
      width: 100%;
      aspect-ratio: 16/9;
      height: auto;
    }

    .video-container video {
      object-fit: fill;
    }

    .module {
      padding-top: 41px;
      margin-left: 16px;
      margin-right: 16px;
    }

    .floating-module {
      margin-left: 16px;
      margin-right: 16px;
    }

    @supports not (gap) {
      .card-container>* {
        margin-bottom: 0px;
      }

      .card-container>:last-child {
        margin-bottom: 0;
      }

    }

  .first-row {
    margin-bottom: 0px;
    /* 移动设备卡片容器之间的间距 */
  }

  .second-row {
    margin-top: 16px;
    /* 避免第二行卡片再有额外的间距 */
  }

  /* 公司简介文字样式 */
  .intro-text {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #595959;
    line-height: 26px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .card:hover {
    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.2);
    box-shadow: none;
    border-radius: 8px 8px 8px 8px;
    border: 0px solid #FFFFFF;
  }

  .card-container {
    flex-direction: column;
    gap: 16px;
    /* 卡片之间的上下间距 */
  }

  .card {
    width: 100%;
    border-radius: 8px;
    height: auto !important;
    padding-bottom: 50px;
  }

  .card1 {
    /* height: 148px; */
  }

  .card2 {
    /* height: 148px; */
    flex: none;
  }

  .card3 {
    /* height: 148px; */
  }

  .card4 {
    /* height: 204px; */
    flex: none;
  }

  .teaching-description {
    margin-top: 20px;
    font-size: 14px;
    text-indent: 2em;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #595959;
    line-height: 26px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
  }

  .text-gap {
    height: 10px
  }

  .back-ground {
    padding-top: 41px;
    /* aspect-ratio: 375 / 310;  */

  }

  .swiper-container-lc {
    padding-top: 24px;
    padding-bottom: 41px;
  }

  .swiper-lc {
    /* height: 238px; */
  }

  .swiper-zr {
    /* height: 382px; */
    /* aspect-ratio: 330 / 310; */
    /* margin-bottom: 48; */

    p.slide-description {
      height: 50px;
    }
  }

  .swiper-container-zr {
    margin-top: 24px;
    margin-bottom: 32px;

  }

  .vision-module {

    margin-top: 24px;
  }

  .vision-text {

    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
    text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.4);
    text-align: center;
    font-style: normal;
    text-transform: none;

  }

  .botton-view {}

  .botton-view-mobile {
    aspect-ratio: unset;
    padding-bottom: 28px;
  }

}
</style>